<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Inspection Note'| translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>
  <div class="ttmodal__body">
    <div class="input-container" style="display: flex;">
      <span class="label" style="color: black;width: 135px;">Inspection Comment <span class="red-text"></span></span>
      
      <textarea rows="10" [(ngModel)]="comment" type="text" placeholder="Comment"  style="width: 450px;" disabled></textarea>

  </div>
  <div class="input-container" style="display: flex;" *ngIf="(FamilyId!=203 && FamilyId!=177)"> 
    <span class="label"  style="color: black;width: 135px;">Interp Comment <span class="red-text"></span></span>
    
    <textarea rows="10" [(ngModel)]="Interpcomment" type="text" placeholder="Interp Comment"  style="width: 450px;" disabled></textarea>

</div>

<div class="input-container" style="display: flex;" *ngIf="(FamilyId!=203 && FamilyId!=177 && InspectionType==10)"> 
  <span class="label"  style="color: black;width: 135px;">Action History <span class="red-text"></span></span>
  <div style="display: flex; flex-direction: column;">
  <ng-container *ngFor="let comment of ActionComment">
   
      <div>
        <span>{{comment.Comment}} </span>
      </div>
  </ng-container>
</div>
  <!-- <textarea rows="10" [(ngModel)]="Interpcomment" type="text" placeholder="Action Comment"  style="width: 450px;" disabled></textarea> -->

</div>
  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()">{{'Cancel'| translate | async}}</button>
  </div>
</div>
` 